export default __webpack_public_path__ + "static/media/dzone_badge.cc776f03.png";